const o="/products",t="/where-to-buy",e="p";export{t as DEFAULT_CONTACT_BUTTON_LINK,o as DEFAULT_PRODUCTS_URL_PREFIX,e as DEFAULT_PRODUCT_PAGE_URL_DIVIDER};
